var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_2792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1786 30.6341C27.9347 31.4634 26.4897 31.9017 25 31.9017C23.5104 31.9017 22.0654 31.4634 20.8215 30.6341L0.33291 16.9746C0.219238 16.8988 0.108496 16.8198 0 16.7386V39.1211C0 41.6873 2.08252 43.7239 4.60283 43.7239H45.3971C47.9633 43.7239 49.9999 41.6414 49.9999 39.1211V16.7385C49.8912 16.8199 49.7803 16.8991 49.6663 16.975L29.1786 30.6341Z",
    fill: "#B39D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.95801 14.5369L22.4466 28.1965C23.2222 28.7136 24.111 28.9721 24.9999 28.9721C25.8889 28.9721 26.7778 28.7135 27.5534 28.1965L48.042 14.5369C49.2681 13.72 50 12.3528 50 10.8772C50 8.34003 47.9358 6.27597 45.3987 6.27597H4.60127C2.06416 6.27607 0 8.34013 0 10.8797C0 12.3528 0.732031 13.72 1.95801 14.5369Z",
    fill: "#B39D5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_2792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.812964a47b442bc1b5e4cec2841a6ec1.svg";
export { ForwardRef as ReactComponent };